ApiPromise = undefined
React = require 'react'
l = require 'lib/localize'
queueRequire -> ApiPromise = require 'network/api-promise'
track = require 'debug/track'
parseURL = require 'url-parse'
_ = require 'underscore'
{ constants } = require 'network/unsplash'
{ RAW_PARAMS } = constants
PhotoAttributionComponent = require 'views/board-create/photo-attribution-component'

SCROLL_BUFFER = 8 # insert marker X thumbs from the end of the list

parseImageLink = (link) ->
  url = parseURL(link, true)
  _.extend(url.query, RAW_PARAMS)

  url.toString()

module.exports = class extends React.Component
  displayName: 'PhotosList'

  constructor: (props) ->
    super(props)

    @state = {
      uploadingImageID: null
    }

  shouldComponentUpdate: (nextProps, nextState) ->
    { images, isLoading } = @props
    { uploadingImageID } = @state

    (images.length isnt nextProps.images.length) or
    (isLoading isnt nextProps.isLoading) or
    (uploadingImageID isnt nextState.uploadingImageID)

  render: ->
    {
      boardId
      collectionID
      connectionError
      images
      isLoading
      maxPage
      page
    } = @props

    shouldShowMore = maxPage > page
    loadingClass = if isLoading then 'logo-loading active' else 'logo-loading'
    thumbs = images.map(@thumbMap)

    if shouldShowMore
      thumbs = @addMarker(thumbs)

    React.createElement(
      'div'
      { className: 'board-backgrounds-list' }
      (
        if thumbs.length
          thumbs
        else if collectionID is 'search' and not isLoading and not connectionError
          React.createElement('div', { className: 'no-results' }, l(['background photos', 'no results']))
      )
      if connectionError
        React.createElement('div', { className: 'error' }, l(['background photos', 'connection error unsplash']))
      React.createElement('div', { className: loadingClass })
    )

  ###################################################
  # Helper functions ################################
  ###################################################

  thumbMap: (image, index) =>
    { uploadingImageID } = @state

    React.createElement(
      'div',
      {
        className: 'board-background-select',
        key: ['thumb', index, image.id].join(':')
        onClick: @setUnsplashBackground(image)
      },
      React.createElement('span',
        {
          className: 'background-box'
          style:
            backgroundImage: 'url(' + image.urls.thumb + ')'
        },
        if uploadingImageID is image.id
          React.createElement('div', { className: 'uploading' },
            React.createElement('span', { className: 'spinner small u-float-left' })
            l(['templates', 'board_background_selection', 'uploading-ellipsis'])
          )
        else
          React.createElement PhotoAttributionComponent,
            user: image.user,
            size: 'large'
      )
    )

  setUnsplashBackground: (image) -> =>
    { boardId } = @props

    track('Board Menu', 'Change Background', "unsplash-#{image.id}")

    @setState( uploadingImageID: image.id )

    ApiPromise(
      url: "/1/boards/#{boardId}/prefs/background"
      type: 'post'
      data:
        url: parseImageLink(image.urls.raw)
    ).finally(=> @setState( uploadingImageID: null ))

  addMarker: (thumbs) =>
    { registerMarker } = @props

    marker = React.createElement('div',
      key: 'marker'
      className: 'scroll-marker'
      ref: registerMarker
    )
    thumbs.splice(-SCROLL_BUFFER, 0, marker)
    thumbs



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/change-board-background-photos-component-view/photos-list.coffee